import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {Icon, Input, Loader, Popup, Table} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {enterKeyCode, tabKeyCode} from '../../../../common/constants/keyCodes';
import {validateUniqueTask} from '../../../utils';
import {HOUR_PRICE} from '../../../constants';
import DeleteIcon from '../../common/icons/DeleteIcon';

const {
  getCampaignTask,
  addMessageBoxError,
  updateTasksArray,
  addElementToTasks,
} = Actions;

const FormParts = ({dataRow, task, handleChange, handleAddItem, handleKeyDown, loadingTask}) => {
  const {taskId, description, flatDealer, flatTde} = dataRow;
  const total = (flatTde * HOUR_PRICE).toFixed(2);
  const validateBtn = description !== task?.description || taskId !== task?.id;

  return (
    <Table.Row textAlign='center'>
      <Table.Cell>
        <Input
          className='twc-part-input code-input'
          placeholder='Operacion'
          value={taskId}
          type='text'
          name='taskId'
          loading={loadingTask}
          onKeyDown={handleKeyDown}
          onChange={handleChange}
        />
      </Table.Cell>
      <Table.Cell>{description}</Table.Cell>
      <Table.Cell>
        <Input
          value={flatDealer}
          type='number'
          min='0'
          step='0.1'
          name='flatDealer'
          disabled={loadingTask}
          onChange={handleChange}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          value={flatTde}
          type='number'
          min='0'
          step='0.1'
          name='flatTde'
          disabled={loadingTask}
          onChange={handleChange}
        />
      </Table.Cell>
      <Table.Cell>{'$'}{total}</Table.Cell>
      <Table.Cell>
        <Popup
          trigger={
            <Icon
              disabled={validateBtn}
              onClick={handleAddItem}
              color='green'
              size='large'
              bordered
              inverted
              name='add'
            />
          }
          content='Añadir trabajo'
          position='top center'
          inverted
        />
      </Table.Cell>
    </Table.Row>
  );
};

const DisplayData = ({item, idx, isUserTde, handleUpdateAmount}) => {
  const {taskId, description, flatDealer, flatTde, total} = item;

  return (
    <Table.Row key={idx} textAlign='center'>
      <Table.Cell>{taskId}</Table.Cell>
      <Table.Cell>{description}</Table.Cell>
      <Table.Cell>{flatDealer}</Table.Cell>
      {isUserTde && (
        <>
          <Table.Cell>{flatTde}</Table.Cell>
          <Table.Cell>
            {'$'}
            {total.toFixed(2)}
          </Table.Cell>
          <Table.Cell>
            <Popup
              trigger={
                <DeleteIcon index={idx} data={item} dataType='tasksArray' />
              }
              content='Eliminar Trabajo'
              position='top center'
              inverted
            />
          </Table.Cell>
        </>
      )}
    </Table.Row>
  );
};

const initialState = {
  'taskId': '',
  'description': '',
  'total': 0.0,
  'flatDealer': 0.0,
  'flatTde': 0.0,
};

const TasksTable = ({dataTable, isUserTde, disabledBtns, task,
  campaingNo, loadingTask, loadingTasksArray}) => {
  const [dataRow, setDataRow] = useState(initialState);
  const [search, setSearch] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (search) {
      const taskValue = task?.id ? task : {'description': ''};

      setDataRow({...dataRow, ...taskValue});
      setSearch(false);
    }
  }, [task]);

  const handleUpdateAmount = (field, value, idx) => {
    const amountValue = isNaN(value) ? 0 : Number(value);
    const newTasks = [...dataTable];
    const newObj = {...newTasks[idx], [field]: amountValue};
    newTasks.splice(idx, 1, newObj);
    dispatch(updateTasksArray(newTasks));
  };

  const handleAddItem = () => {
    const {taskId, flatDealer, flatTde} = dataRow;
    const newTasks = [...dataTable];
    const item = {campaingNo, taskId, 'total': flatTde * HOUR_PRICE,
      'flatDealer': +flatDealer, 'flatTde': +flatTde};

    if (validateUniqueTask(newTasks, taskId)) {
      setDataRow({...initialState});
      dispatch(addElementToTasks(item));
    } else {
      dispatch(
        addMessageBoxError(`El item ${taskId} ya se encuentra en la lista`)
      );
    }
  };

  const handleKeyDown = (e) => {
    const {taskId} = dataRow;
    const name = e.target.name;

    if (e.keyCode === enterKeyCode || e.keyCode === tabKeyCode) {
      if (taskId && name === 'taskId') {
        dispatch(getCampaignTask(taskId));
        setSearch(true);
      } else {
        dispatch(addMessageBoxError(`Ingrese un codigo de ${name} valido`));
      }
    }
  };

  const handleChange = (e, {value, name}) => {
    if (name === 'flatDealer' || name === 'flatTde') {
      const finalValue = Number(value);
      setDataRow({...dataRow, [name]: finalValue < 0 ? 0 : finalValue});
    } else {
      setDataRow({...dataRow, [name]: value.toUpperCase()});
    }
  };

  const renderTableRecords = () => {
    if (!dataTable.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay trabajos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return dataTable.map((task, idx) => (
      <DisplayData
        disabledBtns={disabledBtns}
        handleUpdateAmount={handleUpdateAmount}
        isUserTde={isUserTde}
        key={idx}
        item={task}
        idx={idx}
      />
    ));
  };

  if (loadingTasksArray) {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader
                active
                inline='centered'
                content='Cargando Trabajos'
              />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  return (
    <div className='campaign-container-table'>
      <Table striped>
        <Table.Header>
          <Table.Row textAlign='center'>
            <Table.HeaderCell>OPERACIÓN</Table.HeaderCell>
            <Table.HeaderCell>DESCRIPCIÓN</Table.HeaderCell>
            <Table.HeaderCell>FLAT DEALER</Table.HeaderCell>
            {isUserTde &&
            (
              <>
                <Table.HeaderCell>FLAT TDE</Table.HeaderCell>
                <Table.HeaderCell>VALOR HORA</Table.HeaderCell>
                <Table.HeaderCell>ACCIONES</Table.HeaderCell>
              </>
            )}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {!disabledBtns && isUserTde && (
            <FormParts
              handleChange={handleChange}
              dataRow={dataRow}
              task={task}
              handleAddItem={handleAddItem}
              handleKeyDown={handleKeyDown}
              loadingTask={loadingTask}
            />
          )}
          {renderTableRecords()}
        </Table.Body>
      </Table>
    </div>
  );
};

export default TasksTable;
